import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXPropertyInquiryThankYou implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxPropertyInquiryThankYouContainer";
    }
    render(){
        // console.log("thank you");

    }
}